import { apiGet, apiSend } from './client';
import type { Environment } from '../constants';
import type { IFlag, IFlagEnvironmentInput, IFlagInput, IFlagsPayload } from '../types';

/** Flags are project-wide in WorkOS, so these always go to the first configured API regardless of the stage switcher. */
export const getFlags = (environment: Environment): Promise<{ data: IFlagsPayload }> =>
  apiGet(environment, '/flags');

export const createFlag = (environment: Environment, input: IFlagInput): Promise<{ data: IFlag }> =>
  apiSend(environment, '/flags', 'POST', input);

export const updateFlag = (
  environment: Environment,
  id: string,
  input: IFlagInput,
): Promise<{ data: IFlag }> =>
  apiSend(environment, `/flags/${encodeURIComponent(id)}`, 'PUT', input);

export const deleteFlag = (environment: Environment, id: string): Promise<void> =>
  apiSend(environment, `/flags/${encodeURIComponent(id)}`, 'DELETE');

export const updateFlagEnvironment = (
  environment: Environment,
  flagId: string,
  flagEnvironmentId: string,
  input: IFlagEnvironmentInput,
): Promise<{ data: IFlag }> =>
  apiSend(
    environment,
    `/flags/${encodeURIComponent(flagId)}/environments/${encodeURIComponent(flagEnvironmentId)}`,
    'PUT',
    input,
  );
